<template>
  <div class="section__row">
    <WrapperInput
      label="Prénom"
      :placeholder="utilisateur?.prenom!"
      required
      disabled
    />
    <WrapperInput
      label="Nom"
      :placeholder="utilisateur?.nom!"
      disabled
    />
  </div>
  <WrapperInput
    label="Email"
    :placeholder="utilisateur?.email!"
    disabled
  />
</template>

<script setup lang="ts">
  import { useAppStateStore } from '@/features/application'

  const utilisateur = useAppStateStore().utilisateur
</script>
